import { CheckCircle, ArrowRight, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { pushDataLayer } from "@/lib/gtm";

export default function CheckoutSuccess() {
  const { checkSubscription } = useAuth();

  useEffect(() => {
    checkSubscription();
    pushDataLayer("purchase", { transaction_id: Date.now().toString() });
  }, [checkSubscription]);

  return (
    <div className="container py-16 max-w-xl text-center space-y-6">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/15">
        <CheckCircle className="h-8 w-8 text-primary" />
      </div>
      <h1 className="font-display text-2xl font-bold text-foreground">
        Vielen Dank für Ihre Bestellung!
      </h1>
      <p className="text-muted-foreground leading-relaxed">
        Ihr Abonnement wurde erfolgreich eingerichtet. Sie haben jetzt 30 Tage
        kostenlose Testphase.
      </p>
      <div className="rounded-lg border border-border bg-muted/30 p-4 text-left space-y-2">
        <div className="flex items-center gap-2 text-sm font-medium text-foreground">
          <Clock className="h-4 w-4 text-primary" />
          Wie geht es weiter?
        </div>
        <p className="text-sm text-muted-foreground">
          Wir richten Ihr System mit den gewählten Modulen ein und senden Ihnen
          innerhalb von 24 Stunden Ihre Zugangsdaten per E-Mail. Sie werden
          benachrichtigt, sobald Ihre NextInvoice-Instanz bereit ist.
        </p>
      </div>
      <Button asChild size="lg" className="bg-primary text-primary-foreground">
        <Link to="/portal/dashboard">
          Zum Dashboard
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </Button>
    </div>
  );
}
